import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import style from '../css/betSlipAccordion.css';
import {getText} from './../../../helpers/localization';
import {openCloseBetSlipModal} from './../actions/betSlipActions';
import {OPERATOR} from './../../../constants/operator';
import {ASSETS_URL} from './../../../constants/endpoints';
import {UNREAD_BETS} from "../../../constants/localStorage";
import {openCloseHelpPages} from './../../../actions/helpPagesActions';
import {openCloseSettings} from './../../../actions/settingsActions';
import Counter from './../components/counter';
import {isLocalStorageAvailable} from '../../../helpers/systemHelpers';
import {toggleUnreadBetsNotification} from './../../../actions/systemActions';
import {getItem, setItem} from './../../../helpers/localStorageHelpers';
import {RES, VOIDED} from "../../../constants/identifiers";
import {isBetSettled, removeExpiredBets} from '../helpers/betHelpers';
import {getAccaBetName, getRoundedOdds} from "../modules/matchday/helpers/matchdayHelper";
import { openCloseMyOffer } from '../../../actions/promoBetActions';

const mapStateToProps = (state, ownProps) => {
    return {
        isBetSlipModalOpen: state.vpp.isBetSlipModalOpen,
        openBetsList: state.vpp.openBetsList,
        settledBets: state.vpp.settledBets,
        isSettingsOpen: state.vpp.isSettingsOpen,
        isBetHistoryOpen: state.vpp.isBetHistoryOpen,
        isUnreadBetsNotificationToggled: state.vpp.isUnreadBetsNotificationToggled,
        newPromoFlag: state.vpp.newPromoFlag,
        games: state.vpp.games,
        systemLanguage: state.vpp.systemLanguage,
        serverTimeOffset: state.vpp.serverTimeOffset,
        events: state.vpp.events,
    };
};

class BetSlipAccordion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isBetSlipModalOpen: props.store.getState().vpp.isBetSlipModalOpen,
            openBetsList: props.store.getState().vpp.openBetsList,
            settledBets: props.store.getState().vpp.settledBets,
            isSettingsOpen: props.store.getState().vpp.isSettingsOpen,
            isBetHistoryOpen: props.store.getState().vpp.isBetHistoryOpen,
            isUnreadBetsNotificationToggled: props.store.getState().vpp.isUnreadBetsNotificationToggled,
            newPromoFlag: props.store.getState().vpp.newPromoFlag,
            games: props.store.getState().vpp.games,
            systemLanguage: props.store.getState().vpp.systemLanguage,
            serverTimeOffset: props.store.getState().vpp.serverTimeOffset,
            events: props.store.getState().vpp.events,
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        let existsUnreadSettledBets = false;
        if (isLocalStorageAvailable) {
            let unreadLocalBets = getItem(storeData.vpp.playerUID, UNREAD_BETS);
            if (unreadLocalBets !== undefined && unreadLocalBets !== null) {
                existsUnreadSettledBets =
                    !unreadLocalBets.playerWasNotified &&
                    !unreadLocalBets.isPlaceBetResponse &&
                    unreadLocalBets.settledBets !== undefined &&
                    unreadLocalBets.settledBets.length > 0 &&
                    unreadLocalBets.settledBets.find((bets) => (bets.Bets.find((b) => b.Prize && b.State !== VOIDED) !== undefined && isBetSettled(store, bets, this.state.serverTimeOffset) && !bets.isRead && !bets.isFlashed)) !== undefined;

                if (existsUnreadSettledBets && !this.state.isUnreadBetsNotificationToggled) {
                    this.props.store.dispatch(toggleUnreadBetsNotification());
                    setTimeout(() => this.props.store.dispatch(toggleUnreadBetsNotification()), 10000);
                    unreadLocalBets.playerWasNotified = true;
                    this._setFlashed(unreadLocalBets.settledBets);
                    setItem(storeData.vpp.playerUID, UNREAD_BETS, storeData.vpp.playerUID !== undefined ? unreadLocalBets : {
                        placedBets: [],
                        settledBets: []
                    });
                }
            }
        }


        this.setState({
            openBetsList: storeData.vpp.openBetsList,
            isBetSlipModalOpen: storeData.vpp.isBetSlipModalOpen,
            settledBets: storeData.vpp.settledBets,
            isSettingsOpen: storeData.vpp.isSettingsOpen,
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            isUnreadBetsNotificationToggled: storeData.vpp.isUnreadBetsNotificationToggled,
            newPromoFlag: storeData.vpp.newPromoFlag,
            games: storeData.vpp.games,
            systemLanguage: storeData.vpp.systemLanguage,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            events: storeData.vpp.events,
        });

    }

    _setFlashed(bets) {
        bets.map((sb, index) => {
            sb.isFlashed === true ? '' : sb.isFlashed = true
        });
    }

    _handleExpandCollapse(evt) {
        let expandCollapse = true;
        if (evt && evt.target && evt.target.id && (evt.target.id == 'settings_button' || evt.target.id == 'help_button')) {
            expandCollapse = false;
        }
        if (expandCollapse)
            this.props.store.dispatch(openCloseBetSlipModal());
    }


    render() {

        removeExpiredBets(this.state, this.props.store);

        let helpButton;
        if (OPERATOR.showHelp) {
            helpButton =
                (<div className={style.helpButtonContainer}>
                        <img id={'help_button'} src={`${ASSETS_URL}systemIcons/info.svg`} className={style.helpButton}
                             alt={'help button'} onClick={() => this.props.store.dispatch(openCloseHelpPages())}/>
                    </div>
                );
        }

        let promoButton;
        if(OPERATOR.promoToolEnabled) {
            let promoButtonIconDot = '';
            if (this.state.newPromoFlag) {
                promoButtonIconDot = style.promoButtonDot;
            }
            promoButton =
                (<div className={style.promoButtonContainer}>
                        <img id={'promo_button'} src={`${ASSETS_URL}promo/giftIconWhite.png`}
                             className={style.promoButton}
                             alt={'help button'} onClick={() => this.props.store.dispatch(openCloseMyOffer())}/>
                        <div className={promoButtonIconDot}></div>
                    </div>
                );
        }

        let settingsButton;
        if (OPERATOR.showSettings) {
            settingsButton = (
                <img id={'settings_button'} src={`${ASSETS_URL}systemIcons/cog.svg`} className={style.settingsButton}
                     alt={'settings button'} onClick={() => this.props.store.dispatch(openCloseSettings())}/>);
        }

        let counterUI
        if (this.state.openBetsList.length > 0 && !this.state.isBetSlipModalOpen) {
            counterUI = <Counter animate={true} store={this.props.store}
                                 count={this.state.openBetsList.filter(eventBet => eventBet.bets.length === 1).length}
                                 wrapperStyle={style.counterWrapper}/>
        } else {
            counterUI = <div id='bet_slip_accordion' className={style.counterWrapper}></div>;
        }
        let accordionStyle = `${style.accordion} ${this.state.isUnreadBetsNotificationToggled
            ? style.flashingButton
            : ''}`
        let betslipAcca = '';
        let accaBetItems = this.state.openBetsList.filter(bet =>
            bet.bets.length > 1 &&
            new Set(bet.bets.map(b => b.event.eventId)).size == bet.bets.length
        );
        if (accaBetItems.length == 1 && accaBetItems[0].bets.length > 1) {
            let accaFoldName = getAccaBetName(accaBetItems[0].bets.length, this.props.store);
            let odd = getRoundedOdds(accaBetItems[0].bets, true);
            odd = odd.toString().split(".")[0].length <= 5 ? odd : '';
            let bonus;
            if (OPERATOR.accaBoostBonusEnabled) {
                bonus = JSON.parse(OPERATOR.accaBoostBonusPercentage)[accaBetItems[0].bets.length];
            }
            betslipAcca = <div className={style.betslipAmount}>
                {getText('1', this.props.store) + ' ' + getText('x', this.props.store) + ' '}
                {accaFoldName} {odd}
                {
                    !this.state.isBetSlipModalOpen && OPERATOR.accaBoostBonusEnabled && bonus ?
                        <Fragment><span className={style.plus}> {getText('+', this.props.store)}</span>
                            <span>{getText('Bonus_Info', this.props.store, [bonus])}</span>
                        </Fragment> : ''
                }
            </div>
        }

        return (
            <div className={style.accordionContainer}>
                <div className={accordionStyle}>
                    <div className={`${style.sideContainer} ${style.counter}`}
                         onClick={(evt) => this._handleExpandCollapse(evt)}>
                        <div className={style.counter}>{counterUI}</div>
                        {promoButton}
                    </div>
                    <div className={`${style.sideContainerCenter} ${style.counter}`} onClick={(evt) => this._handleExpandCollapse(evt)}>
                        <div className={`${style.middleContainer} ${style.counter}`}>
                            <div className={style.modalButtonText}>{getText('BET_SLIP', this.props.store)}</div>
                        </div>
                        <div className={`${style.counter}`}
                             onClick={(evt) => this._handleExpandCollapse(evt)}>
                            {betslipAcca}
                        </div>
                    </div>
                    <div className={`${style.sideContainerRight}  ${style.counter}`} onClick={(evt) => this._handleExpandCollapse(evt)}>
                        {helpButton}
                        {settingsButton}
                    </div>
                </div>
                <div className={style.accordionMessageContainer}>
                    <div className={style.accordionMessageInnerContainer}>
                        <div className={style.accordionMessage}>
                            {getText('BET_SELECTION_MESSAGE', this.props.store)}
                        </div>
                    </div>
                </div>
                {this.props.content}
            </div>
        );
    }
}

export default connect(mapStateToProps)(BetSlipAccordion);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/betSlipAccordion.js